
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/submit-documents/pip-document-upload-results",
      function () {
        return require("private-next-pages/g/submit-documents/pip-document-upload-results.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/submit-documents/pip-document-upload-results"])
      });
    }
  